import { render, staticRenderFns } from "./AmountOfMoneyEarnedCmp.vue?vue&type=template&id=2cf6411c&"
import script from "./AmountOfMoneyEarnedCmp.vue?vue&type=script&lang=js&"
export * from "./AmountOfMoneyEarnedCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports